/* global axios */
import ApiClient from '../ApiClient';

class CrmPipelineSettingsAPI extends ApiClient {
  constructor() {
    super('crm_pipeline_settings', {
      saas: true,
      accountScoped: true,
    });
  }

  get() {
    return axios.get(this.url);
  }

  update(data) {
    return axios.patch(this.url, { crm_pipeline_setting: data });
  }
}

export default new CrmPipelineSettingsAPI();
